import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, createRoutesFromElements } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { ScrollToTop } from './components/common/ScrollToTop';
import { Home } from './pages/Home';
import { NameGenerator } from './pages/NameGenerator';
import { ChineseSurnames } from './pages/ChineseSurnames';
import { ChineseBoyNames } from './pages/ChineseBoyNames';
import { ChineseGirlNames } from './pages/ChineseGirlNames';
import { CuteChineseGirlNames } from './pages/CuteChineseGirlNames';
import { FunnyChineseNames } from './pages/FunnyChineseNames';
import { ChinesePetNames } from './pages/ChinesePetNames';
import { ChineseDragonNames } from './pages/ChineseDragonNames';
import { CulturalInsights } from './pages/CulturalInsights';
import { NameMeanings } from './pages/NameMeanings';
import { PronunciationGuide } from './pages/PronunciationGuide';
import { FAQ } from './pages/FAQ';
import Blog from './pages/Blog';
import BlogPost1 from './pages/BlogPost1';
import BlogPost2 from './pages/BlogPost2';
import BlogPost3 from './pages/BlogPost3';
import BlogPost4 from './pages/BlogPost4';
import BlogPost5 from './pages/BlogPost5';
import BlogPost6 from './pages/BlogPost6';
import BlogPost7 from './pages/BlogPost7';
import BlogPost8 from './pages/BlogPost8';
import BlogPost9 from './pages/BlogPost9';
import BlogPost10 from './pages/BlogPost10';
import BlogPost11 from './pages/BlogPost11';
import BlogPost12 from './pages/BlogPost12';
import BlogPost14 from './pages/BlogPost14';
import BlogPost15 from './pages/BlogPost15';
import BlogPost16 from './pages/BlogPost16';
import BlogPost17 from './pages/BlogPost17';
import BlogPost18 from './pages/BlogPost18';
import BlogPost19 from './pages/BlogPost19';
import BlogPost20 from './pages/BlogPost20';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chinese-name-generator" element={<NameGenerator />} />
          {/* 旧URL重定向 */}
          <Route path="/name-generator" element={<Navigate to="/chinese-name-generator" replace />} />
          <Route path="/chinese-boy-names" element={<ChineseBoyNames />} />
          <Route path="/chinese-girl-names" element={<ChineseGirlNames />} />
          <Route path="/cute-chinese-girl-names" element={<CuteChineseGirlNames />} />
          <Route path="/chinese-last-names" element={<ChineseSurnames />} />
          <Route path="/chinese-surnames" element={<Navigate to="/chinese-last-names" replace />} />
          <Route path="/funny-chinese-names" element={<FunnyChineseNames />} />
          <Route path="/chinese-pet-names" element={<ChinesePetNames />} />
          <Route path="/chinese-dragon-names" element={<ChineseDragonNames />} />
          <Route path="/cultural-insights" element={<CulturalInsights />} />
          <Route path="/name-meanings" element={<NameMeanings />} />
          <Route path="/pronunciation" element={<PronunciationGuide />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/how-to-choose-chinese-name" element={<BlogPost1 />} />
          <Route path="/blog/chinese-names-meanings" element={<BlogPost2 />} />
          <Route path="/blog/chinese-names-pronunciation" element={<BlogPost3 />} />
          {/* 不符合架构方案的博客已删除，重定向到相应功能页面 */}
          <Route path="/blog/chinese-name-generator-male" element={<Navigate to="/chinese-boy-names" replace />} />
          <Route path="/blog/female-chinese-names" element={<Navigate to="/chinese-girl-names" replace />} />
          <Route path="/blog/chinese-names-for-girls" element={<Navigate to="/chinese-girl-names" replace />} />
          <Route path="/blog/common-chinese-last-names" element={<Navigate to="/chinese-last-names" replace />} />
          <Route path="/blog/chinese-baby-names" element={<Navigate to="/" replace />} />
          <Route path="/blog/chinese-name-cultural-history" element={<Navigate to="/blog/chinese-family-names-meanings" replace />} />
          <Route path="/blog/chinese-names-for-foreigners" element={<BlogPost11 />} />
          <Route path="/blog/chinese-boy-names-meanings" element={<BlogPost12 />} />
          <Route path="/blog/beautiful-chinese-girl-names-meanings" element={<Navigate to="/cute-chinese-girl-names" replace />} />
          <Route path="/blog/my-name-in-chinese" element={<BlogPost14 />} />
          <Route path="/blog/chinese-name-translation" element={<BlogPost15 />} />
          <Route path="/blog/how-to-say-my-name-in-chinese" element={<BlogPost16 />} />
          <Route path="/blog/chinese-last-name-meanings" element={<BlogPost17 />} />
          <Route path="/blog/chinese-family-names-meanings" element={<BlogPost18 />} />
          <Route path="/blog/what-is-your-name-in-chinese" element={<BlogPost19 />} />
          <Route path="/blog/chinese-signet-rings" element={<BlogPost20 />} />
          <Route path="/blog/funny-chinese-names" element={<Navigate to="/funny-chinese-names" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
